export default class EmailAlreadyExistsError extends Error {
  email: string;

  constructor(email: string) {
    super(`${email} already exists`);

    this.email = email;
  }
}
